module.exports = __webpack_public_path__ + "img/18_24.9e0efb2e.png";